import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import FooterWithCondition from '../Footer/FooterWithCondition';
import ScrollToTop from './ScrollToTop';

const PageFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <span className="eyebrow">Loading</span>
  </div>
);

const MainLayout = () => {
  const location = useLocation();

  return (
    <div className="relative min-h-screen text-ink flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main key={location.pathname} className="flex-1 animate-fade">
        <Suspense fallback={<PageFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <FooterWithCondition />
    </div>
  );
};

export default MainLayout;
